module.exports = require("tty");


//////////////////
// WEBPACK FOOTER
// external "tty"
// module id = 91
// module chunks = 0